module.exports = __webpack_public_path__ + "media/images/patients-processed-ce4497800ed0e9cc28651558f648da7f.svg";